import { DEMO_CONSTANTS } from './demoConstants';

export const mockLocationData = {
    "locationId": "FARM-001",
    "name": DEMO_CONSTANTS.FARM_NAME,
    "latitude": -33.4489,
    "longitude": -70.6693,
    "address": "Región Metropolitana, Chile",
    "totalAnimals": DEMO_CONSTANTS.TOTAL_COWS,
    "activeAnimals": DEMO_CONSTANTS.ACTIVE_COWS
};

export const mockAnimals = [
    {
        "animalId": "NL0000079001",
        "name": "Bella",
        "birthDate": "2020-03-15",
        "breed": "Holstein",
        "status": "active",
        "lactationNumber": 2,
        "healthScore": 92
    },
    {
        "animalId": "NL0000079002",
        "name": "Luna",
        "birthDate": "2019-08-22",
        "breed": "Holstein",
        "status": "active",
        "lactationNumber": 3,
        "healthScore": 88
    },
    {
        "animalId": "NL0000079003",
        "name": "Daisy",
        "birthDate": "2021-01-10",
        "breed": "Jersey",
        "status": "active",
        "lactationNumber": 1,
        "healthScore": 95
    },
    {
        "animalId": "NL0000079004",
        "name": "Rosa",
        "birthDate": "2020-06-18",
        "breed": "Holstein",
        "status": "active",
        "lactationNumber": 2,
        "healthScore": 90
    },
    {
        "animalId": "NL0000079005",
        "name": "Estrella",
        "birthDate": "2019-11-25",
        "breed": "Holstein",
        "status": "active",
        "lactationNumber": 3,
        "healthScore": 85
    }
];

// Helper to generate dates
const getDates = (days: number) => {
    const dates = [];
    for (let i = 0; i < days; i++) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        dates.push(date.toISOString().split('T')[0]);
    }
    return dates;
};

// Generate daily data for the last 30 days
const dailyDates = getDates(30);
export const mockMilkingData = dailyDates.flatMap(date =>
    mockAnimals.map(animal => ({
        "animalId": animal.animalId,
        "date": date,
        "milkYield": 25 + Math.random() * 10, // Random yield between 25 and 35
        "duration": 5 + Math.random() * 3,
        "quality": {
            "protein": 3.0 + Math.random() * 0.5,
            "fat": 3.5 + Math.random() * 1.0,
            "lactose": 4.5 + Math.random() * 0.5,
            "somaticCells": 100000 + Math.floor(Math.random() * 100000),
            "ufc": 10000 + Math.floor(Math.random() * 50000)
        }
    }))
);

export const mockFeedData = dailyDates.flatMap(date =>
    mockAnimals.map(animal => ({
        "animalId": animal.animalId,
        "date": date,
        "feedType": "TMR",
        "amount": 40 + Math.random() * 10,
        "energy": 15 + Math.random() * 5,
        "protein": 6 + Math.random() * 2
    }))
);

// Monthly aggregated data (last 6 months)
export const mockMonthlyData = Array.from({ length: 6 }, (_, i) => {
    const date = new Date();
    date.setMonth(date.getMonth() - i);
    const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

    return {
        month: monthKey,
        totalMilkYield: DEMO_CONSTANTS.DAILY_MILK_PRODUCTION * 30 * (0.9 + Math.random() * 0.2), // Variation around average
        avgQuality: {
            protein: 3.3,
            fat: 3.9,
            somaticCells: 160000
        },
        totalEnergyConsumed: DEMO_CONSTANTS.DAILY_TOTAL_CONSUMPTION * 30,
        totalSolarGenerated: DEMO_CONSTANTS.DAILY_SOLAR_GENERATION * 30 * (0.8 + Math.random() * 0.4) // Weather variation
    };
});


// Helper function to get mock data with delay to simulate API call
export const getMockData = async <T,>(data: T, delay: number = 500): Promise<T> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, delay);
    });
};

// Export functions that mimic API calls
export const getMockAnimals = () => getMockData(mockAnimals);

export const getMockMilkingData = (days: number = 7) => {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - days);

    const filtered = mockMilkingData.filter(item => {
        const itemDate = new Date(item.date);
        return itemDate >= cutoffDate;
    });

    return getMockData(filtered);
};

export const getMockFeedData = (days: number = 7) => {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - days);

    const filtered = mockFeedData.filter(item => {
        const itemDate = new Date(item.date);
        return itemDate >= cutoffDate;
    });

    return getMockData(filtered);
};

export const getMockLocationData = () => getMockData(mockLocationData);

export const getMockMonthlyData = () => getMockData(mockMonthlyData);
